// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.airdrop-metrics {
    background-color: var(--card-background-color);
    border-radius: 8px;
    padding: 24px;
    margin: 24px 0;
    font-family: var(--app-font-family);
}

.airdrop-metrics-header {
    margin-bottom: 24px;
    text-align: center;
}

.airdrop-metrics-header h2 {
    color: var(--primary-color);
    font-family: var(--app-font-family);
    margin: 0;
    font-size: 24px;
}

.airdrop-metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
}

.airdrop-metrics-card {
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 20px;
    text-align: center;
}

.airdrop-metrics-card h3 {
    color: var(--primary-color);
    font-size: 16px;
    margin: 0 0 12px 0;
}

.metric-value {
    font-size: 24px;
    font-weight: bold;
    color: var(--text-color);
}

.airdrop-metrics-charts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 32px;
}

.airdrop-chart-container {
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 20px;
}

.airdrop-chart-container h3 {
    color: var(--primary-color);
    font-size: 18px;
    margin: 0 0 20px 0;
    text-align: center;
}

.airdrop-metrics-percentiles {
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 24px;
}

.airdrop-metrics-percentiles h3 {
    color: var(--primary-color);
    font-size: 18px;
    margin: 0 0 20px 0;
    text-align: center;
}

.percentiles-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    text-align: center;
}

.percentile-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
}

.percentile-label {
    font-size: 14px;
    color: var(--primary-color);
    margin-bottom: 8px;
}

.percentile-value {
    font-size: 20px;
    font-weight: bold;
    color: var(--text-color);
    margin-bottom: 4px;
}

.percentile-unit {
    font-size: 12px;
    color: #666;
}

.airdrop-range {
    text-align: center;
    color: var(--primary-color);
    font-size: 14px;
    margin-top: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
}

@media (max-width: 1200px) {
    .airdrop-metrics-charts {
        grid-template-columns: 1fr;
    }

    .percentiles-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .percentiles-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .percentiles-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/stHype/staking/airdrop_metrics.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".airdrop-metrics {\n    background-color: var(--card-background-color);\n    border-radius: 8px;\n    padding: 24px;\n    margin: 24px 0;\n    font-family: var(--app-font-family);\n}\n\n.airdrop-metrics-header {\n    margin-bottom: 24px;\n    text-align: center;\n}\n\n.airdrop-metrics-header h2 {\n    color: var(--primary-color);\n    font-family: var(--app-font-family);\n    margin: 0;\n    font-size: 24px;\n}\n\n.airdrop-metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 20px;\n    margin-bottom: 32px;\n}\n\n.airdrop-metrics-card {\n    background: white;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    padding: 20px;\n    text-align: center;\n}\n\n.airdrop-metrics-card h3 {\n    color: var(--primary-color);\n    font-size: 16px;\n    margin: 0 0 12px 0;\n}\n\n.metric-value {\n    font-size: 24px;\n    font-weight: bold;\n    color: var(--text-color);\n}\n\n.airdrop-metrics-charts {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-bottom: 32px;\n}\n\n.airdrop-chart-container {\n    background: white;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.airdrop-chart-container h3 {\n    color: var(--primary-color);\n    font-size: 18px;\n    margin: 0 0 20px 0;\n    text-align: center;\n}\n\n.airdrop-metrics-percentiles {\n    background: white;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 24px;\n}\n\n.airdrop-metrics-percentiles h3 {\n    color: var(--primary-color);\n    font-size: 18px;\n    margin: 0 0 20px 0;\n    text-align: center;\n}\n\n.percentiles-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 20px;\n    text-align: center;\n}\n\n.percentile-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.percentile-label {\n    font-size: 14px;\n    color: var(--primary-color);\n    margin-bottom: 8px;\n}\n\n.percentile-value {\n    font-size: 20px;\n    font-weight: bold;\n    color: var(--text-color);\n    margin-bottom: 4px;\n}\n\n.percentile-unit {\n    font-size: 12px;\n    color: #666;\n}\n\n.airdrop-range {\n    text-align: center;\n    color: var(--primary-color);\n    font-size: 14px;\n    margin-top: 16px;\n    padding: 12px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n@media (max-width: 1200px) {\n    .airdrop-metrics-charts {\n        grid-template-columns: 1fr;\n    }\n\n    .percentiles-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .percentiles-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .percentiles-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
